import { render } from "./recycleBin.vue?vue&type=template&id=0ad868f7&scoped=true"
import script from "./recycleBin.vue?vue&type=script&lang=js"
export * from "./recycleBin.vue?vue&type=script&lang=js"

import "./recycleBin.vue?vue&type=style&index=0&id=0ad868f7&scoped=true&lang=scss"
import "./recycleBin.vue?vue&type=style&index=1&id=0ad868f7&lang=scss&scoped=true"
import "./recycleBin.vue?vue&type=style&index=2&id=0ad868f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad868f7"]])

export default __exports__